import { render, staticRenderFns } from "./gamifyGlobalUpdate.vue?vue&type=template&id=665b11a4&lang=pug"
import script from "./gamifyGlobalUpdate.vue?vue&type=script&lang=js"
export * from "./gamifyGlobalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports